import { ReactElement, ReactNode, useEffect, useRef, useState } from 'react';
import { CopyOutlined, CheckOutlined } from '@ant-design/icons';
import copy from 'copy-to-clipboard';
import { SFrame, SCopy, SContainer } from './CopyableCell.style';

export const CopyableCell = ({ children, text }: { children: ReactNode; text?: string }): ReactElement => {
  const ref = useRef<HTMLDivElement | null>(null);
  const [hovered, setHovered] = useState(false);
  const [copied, setCopied] = useState(false);
  const timeoutId = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    const tdNode = ref.current?.closest('td');

    const onMouseEnter = (): void => {
      if (tdNode) {
        tdNode.style.background = 'white';
      }
      setHovered(true);
    };
    const onMouseLeave = (): void => {
      if (tdNode) {
        tdNode.style.background = '';
      }
      setHovered(false);
    };

    if (tdNode) {
      tdNode.style.cursor = 'pointer';
      tdNode.addEventListener('mouseenter', onMouseEnter);
      tdNode.addEventListener('mouseleave', onMouseLeave);
    }
    return (): void => {
      if (tdNode) {
        tdNode.removeEventListener('mouseenter', onMouseEnter);
        tdNode.removeEventListener('mouseleave', onMouseLeave);
        tdNode.style.cursor = '';
      }
    };
  }, []);

  return (
    <SContainer ref={ref}>
      {hovered && (
        <SFrame
          onClick={(): void => {
            copy(text || String(children) || '');
            setCopied(true);
            if (timeoutId.current) window.clearTimeout(timeoutId.current);
            window.setTimeout(() => {
              setCopied(false);
            }, 3000);
          }}
        >
          <SCopy>{copied ? <CheckOutlined /> : <CopyOutlined />}</SCopy>
        </SFrame>
      )}

      {children}
    </SContainer>
  );
};

export const renderCopyableCell = (text: string): ReactElement => <CopyableCell>{text}</CopyableCell>;
